export default function head__setTitle(title, lang) {
  const string = `${title[lang] ? title[lang] : title.default} | E-catalog`;
  return string;
}
